import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import styled from "styled-components";

ModuleRegistry.registerModules([ AllCommunityModule ]);

const Container = styled.div`
  height: 100%;
  width: 100%;
  
  --ag-foreground-color: #080808;
`

export default ({
  data,
  cols,
  filter,
  isDisableAutoHeight,
  isDisableAutoWidth,
  isLoading,
  isShowCheckboxColumn = false,
  isShowCheckboxHeader = false,
  style,
  onSelection
}) => {
  
  const onSelectionChanged = (event) => {
    onSelection?.(event.api.getSelectedRows())
  }

  return (
    <Container style={style}>
      <AgGridReact 
        rowData={data} 
        columnDefs={cols}
        defaultColDef={{
          ...(isDisableAutoWidth ? {} : { flex: 1 })
        }}
        rowSelection={{
          mode: 'multiRow',
          checkboxes: isShowCheckboxColumn,
          checkboxSelection: isShowCheckboxColumn,
          headerCheckbox: isShowCheckboxHeader,
          headerCheckboxSelection: isShowCheckboxHeader,
          headerCheckboxSelectionFilteredOnly: isShowCheckboxHeader
        }}
        quickFilterText={filter}
        loading={isLoading}
        enableCellTextSelection={true}
        enableBrowserTooltips={true}
        ensureDomOrder={true}
        domLayout={isDisableAutoHeight ? undefined : 'autoHeight'}
        onSelectionChanged={onSelectionChanged}
      />
    </Container>
  )
}